export const comments_5160004 = {"data":{"data":[],"links":{}}}